'use client';

import Container from '@/src/components/ui/container';
import { ThemeLayout } from './ThemeLayout';
import Typography from '@/src/components/ui/typography';
import { ICmsBranch, ICmsTheme } from '../services/types';
import { SliderLayout } from '@/src/components/Layout/SliderLayout';
import CmsStoreCard from './CmsStoreCard';

type Props = {
  theme: ICmsTheme;
  name: string;
  stores: ICmsBranch[];
  globalLiveTimes?: Record<number, string>; // استقبال الـ Map من الأب
};

export const NearbyStores = ({ theme, name, stores, globalLiveTimes }: Props) => {
  return (
    <Container>
      <ThemeLayout
        id={stores[0]?.id?.toString() || 'nearby-stores'}
        theme={theme}
        alt="trading Stores"
        header={
          <Typography
            variant="h4"
            component={'h2'}
            weight={'semibold'}
            align="start"
            className="text-inherit"
          >
            {name}
          </Typography>
        }
      >
        {stores?.length > 0 && (
          <SliderLayout
            itemsClassName="lg:basis-[13%] md:basis-[16%] basis-[30%] md:pl-4 pl-1 "
            conatinerClassName="lg:ps-6 ps-3"
          >
            {stores.map((store, index) => {
              // جلب الوقت الحي بـ O(1) بالـ ID الحقيقي للمتجر من الأب مباشرة
              const storeId = store.store?.id || store.id;
              const liveTime = globalLiveTimes?.[storeId] || '';

              return (
                <CmsStoreCard key={index} store={store} isNearby liveDeliveryTime={liveTime} />
              );
            })}
          </SliderLayout>
        )}
      </ThemeLayout>
    </Container>
  );
};
